import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const channelCampaignSchema = z
  .object({
    name: z.string(),
    state: z.string(),
    campaignId: z.string(),
  })
  .passthrough();

export const channelCampaignsApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "listChannelCampaigns",
    method: "get",
    path: "/channel_campaigns",
    parameters: [
      { name: "marketplace", type: "Query", schema: z.string().optional() },
      { name: "q", type: "Query", schema: z.string().optional() },
      { name: "mediaplan_type", type: "Query", schema: z.string().optional() },
      { name: "state", type: "Query", schema: z.string().optional() },
    ],
    status: 200,
    response: z.array(channelCampaignSchema),
  }).build(),
);
